import React, { useState, useEffect, useRef, useLayoutEffect } from 'react'
import MusicTrack from './MusicTrack'
import "../css/music.css"
import { client } from '../client'
import { motion, useScroll, useTransform, AnimatePresence, useSpring } from "framer-motion"
import musicHeader from "../assets/ghetto2000.webp"
import ByManta from './ByManta'
import Copyright2 from './Copyright2'
import Footer from './Footer'
import { useInView } from 'react-intersection-observer'
import musicsvg from '../assets/music.svg'


const Music = ({ windowWidth }) => {

const [musicData, setMusicData] = useState(null)
const [filtered, setFiltered] = useState()
const [activeCategory, setCategory] = useState(3)
const [activeVideo, setVideo] = useState(false)

const [ ref2, inView2 ] = useInView()

const targetRef = useRef()
const contentRef = useRef()
const innerRef = useRef(null) 
const spacerRef = useRef()
const columnsRef = useRef(null);


const { scrollY } = useScroll();

  // Smooth the scroll
const smoothY = useSpring(scrollY, {
    damping: 40,
    stiffness: 200,
    mass: 0.2,
});

const inverted = useTransform(smoothY, v => -v)

const y = useTransform(smoothY, [0, 1600], [0, 300])
const y2 = useTransform(smoothY, [0, 1600], [0, 150])



useEffect(() => {
    client.fetch(`*[_type == "music"]{
        date,
        category,
        artist,
        title,
        "imageUrl": image.asset->url,
        apple,
        spotify,
        youtube
    }`)
    .then((data) => setMusicData(data))
    .catch(console.error)
}, [])


let title = {
    closed: { opacity: 1 },
    open: { opacity: 1, transition: { delayChildren: 1.2, staggerChildren: 0.1 }}
}

let letters = {
    closed: { y: "24vw" },
    open: { y: 0, transition: { duration: 1, ease: [0.5, 0.7, 0.05, 1] } }
}


useEffect(() => {
    if (activeCategory === 3) {
        setFiltered(musicData)
        return
    }
    const filt = musicData.filter((music) =>
    music.category.toString().includes(activeCategory)
    )
    setFiltered(filt)
}, [ musicData, activeCategory ])


useLayoutEffect(() => {
    const el = innerRef.current;
    if (!el) return;

    const update = () => {
      const h = el.getBoundingClientRect().height;
      spacerRef.current.style.height = `${h}px`;
    };

    update(); // initial

    const observer = new ResizeObserver(update);
    observer.observe(el);

    return () => observer.disconnect();
  }, []);


const header = { 
    open: { height: "100%" },
}

useLayoutEffect(() => {
  if (!columnsRef.current) return;

  console.log(
    "music-columns height:",
    columnsRef.current.getBoundingClientRect().height
  );
}, [filtered]);





  return (
    <AnimatePresence mode="wait">
        
    <div className="music-container">
        <Copyright2 />
        <ByManta />
        <Footer inView2={ inView2 } /> 
        
        <div className='filter-container'>
            <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0, transition: { delay: 1, duration: 1.6 }}} className={activeCategory === 3 ? "active" : ""} onClick={() => {setCategory(3)}}>All</motion.button>
            <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0, transition: { delay: 1, duration: 1.8 }}} className={activeCategory === 0 ? "active" : ""} onClick={() => {setCategory(0)}}>Albums</motion.button>
            <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0, transition: { delay: 1, duration: 2.0 }}} className={activeCategory === 1 ? "active" : ""} onClick={() => {setCategory(1)}}>Singles</motion.button>
            <motion.button initial={{ opacity: 0, y: 10 }} animate={{ opacity: 1, y: 0, transition: { delay: 1, duration: 2.2 }}} className={activeCategory === 2 ? "active" : ""} onClick={() => {setCategory(2)}}>Remixes</motion.button>
        </div>

        <motion.div ref={ contentRef } style={{ y: inverted, position: 'relative' }}>
            <div ref={ innerRef }>
                
                    <motion.div variants={header} animate={ activeVideo && "open" } className="music-spacer">
                        <motion.div variants={header} animate={ activeVideo && "open" } className="music-header">

                            { activeVideo ? 
                            <div className='music-video-grid'><div className="music-video-spacer"></div>
                            <div className="music-video-wrapper">
                            <iframe className='youtube-video' src={activeVideo} title="YouTube Video" autoplay={"true"} color={"white"} allowFullScreen /> 
                            </div>
                            </div>
                            : 
                            <div className='music-header' style={{ overflow: "hidden", zIndex: 200 }}>
                            {/* <div className="black-overlay"></div> */}

                            <motion.img initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 2.5, duration: 1 }}} ref={targetRef} src={musicHeader} width="100%" height="100%" style={{ objectFit: "cover", position: "absolute", top: 0, objectPosition: '50% 20%', y: y2 }} /> 
                            <motion.div style={{ height: 'max-content', width: 'clamp(260px, 70vw, 50vw)', y }} 
                                                // variants={ title } initial="closed" 
                                                // animate="open" 
                                                className="contact-text">
                                                    <div style={{ display: 'flex', width: '100%', height: 'max-contact', overflow: 'hidden',  }}>
                                                      <motion.img src={ musicsvg } initial={{ y: '180%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1 }  }} style={{ width: '100%', height: 'auto' }} />
                                                    </div>
                                                  <div style={{ height: '14px', position: 'absolute', bottom: -18, left: 0, overflow: 'hidden' }}>
                                                    <motion.h5 initial={{ y: '100%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1.6 } }} style={{ marginTop: '-2px' }}>"TRUE</motion.h5>
                                                  </div>
                                                  <div style={{ height: '14px', position: 'absolute', bottom: -18, right: 0, overflow: 'hidden' }}>
                                                    <motion.h5 initial={{ y: '100%' }} animate={{ y: '0%', transition: { ease: [0.9, 0.5, 0, 0.8], duration: 1, delay: 1.8 } }} style={{ marginTop: '-2px' }}>FEELING"</motion.h5>
                                                  </div>
                                                </motion.div>
                            </div>
                            }
                        </motion.div>
                    </motion.div>

                <div className='music-container-columns'>
                    <div></div>
                    <motion.div className='music-columns' ref={ columnsRef } initial={{ opacity: 0 }} animate={{ opacity: 1, transition: { delay: 2 } }} style={{ backgroundColor: "black", zIndex: 1000 }} >
                        { filtered && filtered
                        .sort((a, b) => a.date < b.date ? 1 : -1)
                        .map(( music ) => { 
                            return (
                                <MusicTrack  
                                setVideo={setVideo}
                                activeVideo={activeVideo}
                                id={music.date}
                                key={music.date} 
                                artist={music.artist} 
                                title={music} 
                                image={music.imageUrl}
                                category={music.category}
                                youtube={music.youtube}
                                date={music.date}
                                /> 
                            )}
                            )
                        }
                    </motion.div>
                    <div style={{ height: '180px' }}></div>
                </div>
                <motion.div initial={{ height: 0 }} animate={{ height: 160, transition: { delay: 2 } }} className='bottom-spacer'></motion.div>
                <div ref={ ref2 } style={{ width: '10px', height: '1px', marginTop: '-1px' }}></div>
            </div>
       
        </motion.div>
        
        
    </div>
     <div style={{ position: 'relative' }} ref={ spacerRef }></div>
     
    </AnimatePresence>
  )
}

export default Music